// Lectura rápida de la etiqueta de una balanza etiquetadora.
//
// Vive en su propio módulo y no dentro de Pos.tsx por dos razones: se puede
// testear sin montar la pantalla de venta, y un archivo que exporta un
// componente Y una función pierde el refresco en caliente del desarrollo.

/**
 * Lee un EAN-13 de balanza etiquetadora.
 *
 * El layout REAL lo define la configuración del tenant y lo decodifica el
 * servidor (Application/Balanza/CodigoBalanzaParser.cs), que es donde tiene
 * que estar: cada marca arma la etiqueta distinto y el parser es
 * configurable.
 *
 * Acá hay una lectura mínima del formato más común —prefijo 2, cinco dígitos
 * de PLU, cinco de valor— con un solo propósito: distinguir de inmediato una
 * etiqueta de balanza de un código de barras normal, sin ir al servidor. El
 * cajero pasa el lector y la línea entra sin latencia.
 *
 * Si el layout del cliente no es este, el código cae en la búsqueda normal
 * del catálogo y el servidor lo resuelve. No se pierde nada.
 */
export function leerEtiquetaBalanza(
  codigo: string,
): { plu: number; valor: number; esImporte: boolean } | null {
  if (!/^\d{13}$/.test(codigo)) return null

  // Los prefijos 20 a 29 están reservados por GS1 para uso interno del
  // comercio: es donde viven las etiquetas de balanza en todo el mundo.
  const prefijo = Number(codigo.slice(0, 2))
  if (prefijo < 20 || prefijo > 29) return null

  const plu = Number(codigo.slice(2, 7))
  const valor = Number(codigo.slice(7, 12))

  if (!plu || !valor) return null

  // El prefijo 21 suele indicar importe y el 20 peso. Es una convención, no
  // un estándar: por eso el layout de verdad se configura por tenant y esto
  // es solo el atajo del caso más común.
  const esImporte = prefijo === 21

  return { plu, valor, esImporte }
}
